import React from 'react';
import { IllustrationProps } from '../../../../../types/Common';
import useToggleIllustrationColors from '../../hooks/useToggleIllustrationColors';

const IllustrationInsuranceMotoWA: React.FC<
  React.PropsWithChildren<IllustrationProps>
> = ({ isActive = true, ...otherProps }) => {
  const colors = useToggleIllustrationColors(isActive);
  return (
    <svg
      width={356}
      height={228}
      viewBox="0 0 356 228"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <mask
        id="mask0_1864_6926"
        style={{ maskType: 'alpha' }}
        width="356"
        height="228"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#C0C2C9" d="M0 0h356v228H0V0z"></path>
      </mask>
      <g mask="url(#mask0_1864_6926)">
        <path
          fill={colors.primary[50]}
          d="M337 161c0 88.366-71.634 160-160 160S17 249.366 17 161 88.634 1 177 1s160 71.634 160 160z"
        ></path>
        <path
          fill={colors.primary[200]}
          fillRule="evenodd"
          d="M155.901 142.041a2 2 0 00-2.361 1.558l-8.5 41.5a2.001 2.001 0 003.919.803l8.5-41.5a2 2 0 00-1.558-2.361zM122.894 144.212a2 2 0 00-2.683.894l-16 32a2 2 0 103.577 1.789l16-32a2 2 0 00-.894-2.683z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[50]}
          d="M224 191c0 18.778 15.222 34 34 34s34-15.222 34-34-15.222-34-34-34-34 15.222-34 34z"
        ></path>
        <path
          fill={colors.primary[200]}
          fillRule="evenodd"
          d="M258 221c-16.569 0-30-13.431-30-30 0-16.569 13.431-30 30-30 16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30zm0 4c-18.778 0-34-15.222-34-34s15.222-34 34-34 34 15.222 34 34-15.222 34-34 34z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#fff"
          d="M239.692 191c0 10.111 8.197 18.308 18.308 18.308s18.308-8.197 18.308-18.308-8.197-18.308-18.308-18.308-18.308 8.197-18.308 18.308z"
        ></path>
        <path
          fill={colors.primary[200]}
          fillRule="evenodd"
          d="M258 205.308c-7.902 0-14.308-6.406-14.308-14.308s6.406-14.308 14.308-14.308 14.308 6.406 14.308 14.308-6.406 14.308-14.308 14.308zm0 4c-10.111 0-18.308-8.197-18.308-18.308s8.197-18.308 18.308-18.308 18.308 8.197 18.308 18.308-8.197 18.308-18.308 18.308z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[50]}
          d="M65 191c0 18.778 15.222 34 34 34s34-15.222 34-34-15.222-34-34-34-34 15.222-34 34z"
        ></path>
        <path
          fill={colors.primary[200]}
          fillRule="evenodd"
          d="M99 221c-16.569 0-30-13.431-30-30 0-16.569 13.431-30 30-30 16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30zm0 4c-18.778 0-34-15.222-34-34s15.222-34 34-34 34 15.222 34 34-15.222 34-34 34z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#fff"
          d="M80.692 191c0 10.111 8.197 18.308 18.308 18.308s18.308-8.197 18.308-18.308-8.197-18.308-18.308-18.308S80.692 180.889 80.692 191z"
        ></path>
        <path
          fill={colors.primary[200]}
          fillRule="evenodd"
          d="M99 205.308c-7.902 0-14.308-6.406-14.308-14.308S91.098 176.692 99 176.692s14.308 6.406 14.308 14.308-6.406 14.308-14.308 14.308zm0 4c-10.111 0-18.308-8.197-18.308-18.308S88.89 172.692 99 172.692s18.308 8.197 18.308 18.308-8.197 18.308-18.308 18.308zM226.069 130.73a2 2 0 00-.84 2.701l31 59a2 2 0 003.541-1.861l-31-59a2 2 0 00-2.701-.84z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[200]}
          fillRule="evenodd"
          d="M260 149a2 2 0 00-2-2c-10.864 0-26.071 4.115-35.083 15.777a2.001 2.001 0 003.166 2.446C234.071 154.885 247.864 151 258 151a2 2 0 002-2zM134.437 144.93c6.808.365 13.974-1.574 21.914-7.147a1.999 1.999 0 112.298 3.274c-8.56 6.008-16.595 8.287-24.426 7.867-7.777-.417-15.141-3.487-22.4-7.784a2 2 0 012.038-3.442c6.997 4.142 13.713 6.864 20.576 7.232z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[200]}
          fillRule="evenodd"
          d="M145.028 185.834c-5.779-34.191-37.503-47.825-62.953-36.242a2 2 0 11-1.657-3.64c27.814-12.66 62.333 2.406 68.554 39.215a2 2 0 11-3.944.667z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[100]}
          d="M240 125c-3.5 0-7.5 2-14 7.5 6 5.5 9 8 14 8 3 1.5 3.5-15.5 0-15.5z"
        ></path>
        <path
          fill={colors.primary[200]}
          fillRule="evenodd"
          d="M242.78 124.6c-.506-.741-1.413-1.6-2.78-1.6-4.284 0-8.775 2.459-15.292 7.973a2 2 0 00-.059 3.001c5.778 5.297 9.31 8.399 14.998 8.522a2.69 2.69 0 001.374.017c.657-.165 1.137-.545 1.46-.898.605-.662.962-1.557 1.193-2.33.488-1.628.731-3.816.764-5.942.032-2.133-.144-4.402-.601-6.202-.224-.886-.552-1.801-1.057-2.541zm-3.058 13.897c-3.541-.076-5.893-1.636-10.667-5.924 5.068-4.062 8.121-5.418 10.514-5.56.115.221.257.581.391 1.112.34 1.34.508 3.228.478 5.157-.03 1.936-.255 3.718-.596 4.855a5.385 5.385 0 01-.12.36z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#fff"
          d="M225 137.591c0-12.103-11.212-21.09-23.025-18.456l-39.684 8.848A14.432 14.432 0 00151 142.069c0 7.971 6.461 14.432 14.432 14.432h40.658c10.444 0 18.91-8.466 18.91-18.91z"
        ></path>
        <path
          fill={colors.primary[200]}
          fillRule="evenodd"
          d="M163.161 131.887l39.685-8.848c9.314-2.077 18.154 5.009 18.154 14.552 0 8.235-6.675 14.91-14.91 14.91h-40.658a10.433 10.433 0 01-2.271-20.614zm38.814-12.752c11.813-2.634 23.025 6.353 23.025 18.456 0 10.444-8.466 18.91-18.91 18.91h-40.658c-7.971 0-14.432-6.461-14.432-14.432 0-6.76 4.693-12.615 11.291-14.086l39.684-8.848z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[100]}
          d="M148 174.818c0-9.721 9.556-16.561 18.757-13.426l23.409 7.975a10.087 10.087 0 01-3.252 19.634h-24.731c-7.833 0-14.183-6.35-14.183-14.183z"
        ></path>
        <path
          fill={colors.primary[200]}
          fillRule="evenodd"
          d="M188.876 173.154l-23.409-7.976c-6.606-2.25-13.467 2.661-13.467 9.64 0 5.624 4.559 10.183 10.183 10.183h24.731a6.086 6.086 0 001.962-11.847zm-22.119-11.762c-9.201-3.135-18.757 3.705-18.757 13.426 0 7.833 6.35 14.183 14.183 14.183h24.731a10.087 10.087 0 003.252-19.634l-23.409-7.975z"
          clipRule="evenodd"
        ></path>
        <path
          fill={colors.primary[200]}
          fillRule="evenodd"
          d="M196.162 164.213a2 2 0 001.05 2.626l8.626 3.697c-2.564 5.675-6.874 15.21-8.659 19.137-1.104 2.429-2.313 3.524-3.484 4.088-1.251.602-2.729.74-4.695.74h-44.5v4H189c2.034 0 4.306-.113 6.43-1.136 2.204-1.061 3.995-2.966 5.391-6.037 2.001-4.403 7.169-15.838 9.502-21.004a1.999 1.999 0 00-1.035-2.662l-10.5-4.5a2 2 0 00-2.626 1.051zM200.143 106.258a2 2 0 001.114 2.599c2.41.964 8.9 3.913 15.183 7.84 2.711 1.694 4.664 4.606 5.991 7.765 1.319 3.142 1.924 6.307 2.075 8.198a2 2 0 003.988-.319c-.183-2.276-.877-5.86-2.375-9.427-1.49-3.55-3.87-7.304-7.559-9.609-6.518-4.074-13.227-7.125-15.817-8.161a1.999 1.999 0 00-2.6 1.114z"
          clipRule="evenodd"
        ></path>
        <g filter="url(#filter0_dd_1864_6926)">
          <circle cx="233" cy="85" r="55" fill="#fff"></circle>
          <circle
            cx="233"
            cy="85"
            r="53"
            stroke={colors.primary[500]}
            strokeWidth="4"
          ></circle>
        </g>
        <path
          fill={colors.primary[200]}
          d="M228.096 91.488l-7.584-23.52h-6.864l-7.536 23.424-6.24-23.424h-7.008L202.32 102h6.912l7.776-24.24 7.776 24.24h6.816l9.408-34.032h-6.768l-6.144 23.52zM266.412 102h7.2l-12.96-34.032h-7.68L239.916 102h7.008l2.832-7.776h13.824l2.832 7.776zm-9.744-26.688l4.704 12.864h-9.408l4.704-12.864z"
        ></path>
        <path
          fill={colors.primary[500]}
          d="M228.096 91.488l-1.428.46a1.5 1.5 0 002.879-.08l-1.451-.38zm-7.584-23.52l1.428-.46a1.5 1.5 0 00-1.428-1.04v1.5zm-6.864 0v-1.5c-.651 0-1.228.42-1.428 1.04l1.428.46zm-7.536 23.424l-1.449.386a1.499 1.499 0 002.877.073l-1.428-.459zm-6.24-23.424l1.449-.386a1.5 1.5 0 00-1.449-1.114v1.5zm-7.008 0v-1.5a1.498 1.498 0 00-1.445 1.902l1.445-.402zM202.32 102l-1.445.402c.18.649.771 1.098 1.445 1.098V102zm6.912 0v1.5a1.5 1.5 0 001.428-1.042l-1.428-.458zm7.776-24.24l1.428-.458a1.5 1.5 0 00-2.856 0l1.428.458zm7.776 24.24l-1.428.458a1.5 1.5 0 001.428 1.042V102zm6.816 0v1.5a1.5 1.5 0 001.446-1.1l-1.446-.4zm9.408-34.032l1.446.4a1.501 1.501 0 00-1.446-1.9v1.5zm-6.768 0v-1.5a1.5 1.5 0 00-1.451 1.12l1.451.38zm-4.716 23.06l-7.584-23.52-2.856.92 7.584 23.52 2.856-.92zm-9.012-24.56h-6.864v3h6.864v-3zm-8.292 1.04l-7.536 23.425 2.856.918 7.536-23.424-2.856-.918zm-4.659 23.498l-6.24-23.424-2.898.772 6.24 23.424 2.898-.772zm-7.689-24.538h-7.008v3h7.008v-3zm-8.453 1.902l9.456 34.032 2.89-.804-9.456-34.032-2.89.804zm10.901 35.13h6.912v-3h-6.912v3zm8.34-1.042l7.776-24.24-2.856-.916-7.776 24.24 2.856.916zm4.92-24.24l7.776 24.24 2.856-.916-7.776-24.24-2.856.916zm9.204 25.282h6.816v-3h-6.816v3zm8.262-1.1l9.408-34.032-2.892-.8-9.408 34.032 2.892.8zm7.962-35.932h-6.768v3h6.768v-3zm-8.219 1.12l-6.144 23.52 2.902.76 6.144-23.52-2.902-.76zM266.412 102l-1.409.513a1.5 1.5 0 001.409.987V102zm7.2 0v1.5a1.5 1.5 0 001.402-2.034l-1.402.534zm-12.96-34.032l1.402-.534a1.5 1.5 0 00-1.402-.966v1.5zm-7.68 0v-1.5c-.621 0-1.178.383-1.4.963l1.4.537zM239.916 102l-1.4-.537a1.5 1.5 0 001.4 2.037V102zm7.008 0v1.5a1.5 1.5 0 001.41-.987l-1.41-.513zm2.832-7.776v-1.5a1.5 1.5 0 00-1.409.987l1.409.513zm13.824 0l1.41-.513a1.5 1.5 0 00-1.41-.987v1.5zm-6.912-18.912l1.409-.515a1.5 1.5 0 00-2.817 0l1.408.515zm4.704 12.864v1.5a1.501 1.501 0 001.409-2.015l-1.409.515zm-9.408 0l-1.408-.515a1.5 1.5 0 001.408 2.015v-1.5zm14.448 15.324h7.2v-3h-7.2v3zm8.602-2.034l-12.96-34.032-2.803 1.068 12.96 34.032 2.803-1.068zm-14.362-34.998h-7.68v3h7.68v-3zm-9.08.963l-13.056 34.032 2.801 1.074 13.056-34.032-2.801-1.074zM239.916 103.5h7.008v-3h-7.008v3zm8.418-.987l2.832-7.776-2.819-1.026-2.832 7.776 2.819 1.026zm1.422-6.789h13.824v-3h-13.824v3zm12.415-.987l2.832 7.776 2.819-1.026-2.832-7.776-2.819 1.026zm-6.911-18.91l4.704 12.864 2.817-1.03-4.704-12.864-2.817 1.03zm6.112 10.849h-9.408v3h9.408v-3zm-7.999 2.015l4.704-12.864-2.817-1.03-4.704 12.864 2.817 1.03z"
        ></path>
        <path
          fill={colors.primary[500]}
          fillRule="evenodd"
          d="M20 226a2 2 0 012-2h310a2 2 0 110 4H22a2 2 0 01-2-2z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_dd_1864_6926"
          width="142"
          height="142"
          x="162"
          y="22"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="8"></feOffset>
          <feGaussianBlur stdDeviation="8"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1864_6926"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.04 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_1864_6926"
            result="effect2_dropShadow_1864_6926"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1864_6926"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
};

export default IllustrationInsuranceMotoWA;
